/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Partial_FillInputs */

const cs_ruian_partial_fill = /** @type {(inputs: Ruian_Partial_FillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyplněna známá pole. Doplňte číslo popisné a další údaje.`)
};

const en_ruian_partial_fill = /** @type {(inputs: Ruian_Partial_FillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filled known fields. Add the house number and anything else that is missing.`)
};

/**
* | output |
* | --- |
* | "Filled known fields. Add the house number and anything else that is missing." |
*
* @param {Ruian_Partial_FillInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_partial_fill = /** @type {((inputs?: Ruian_Partial_FillInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Partial_FillInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_partial_fill(inputs)
	return cs_ruian_partial_fill(inputs)
});